const chartTheme = {
  axis: {
    ticks: {
      text: {
        fontFamily: "Manrope, sans-serif",
        fontSize: 12,
        fontWeight: 400
      }
    },
    legend: {
      text: {
        fontFamily: "Manrope, sans-serif",
        fontSize: 14,
        fontWeight: 500
      }
    }
  },
  legends: {
    text: {
      fontFamily: "Manrope, sans-serif",
      fontSize: 12,
      fontWeight: 400
    }
  },
  labels: {
    text: {
      fontFamily: "Manrope, sans-serif",
      fontSize: 12,
      fontWeight: 400
    }
  },
  tooltip: {
    container: {
      fontFamily: "Manrope, sans-serif",
      fontSize: 12,
      fontWeight: 400
    }
  }
};

export default chartTheme;
